import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: string): string {
    let d, newDate;
    if(value){
      d = new Date(value);
      newDate = d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
    } else {
      newDate = '-';
    }

    return newDate;
  }

}
